// Import Swiper React components
import { Swiper, SwiperSlide } from 'swiper/react';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/navigation';

import './Slider.css';

// import required modules
import { Navigation } from 'swiper/modules';

const SliderBanner = () => {
    return (
        <>
            <Swiper navigation={true} modules={[Navigation]} className="mySwiper">
                <SwiperSlide >
                    <div className='' style={{backgroundImage: 'url(/assets/images/main-slider/1.jpg)',height:'100vh',width:"100%"}}></div>
                {/* <img alt="" class="rev-slidebg" data-bgfit="cover" data-bgparallax="20" data-bgposition="center center" data-bgrepeat="no-repeat" data-no-retina="" src="/assets/images/main-slider/1.jpg"/>  */}
                <div className='overlay'></div>
                </SwiperSlide>
                <SwiperSlide>
                <div className='' style={{backgroundImage: 'url(/assets/images/main-slider/2.jpg)',height:'100vh',width:"100%"}}></div>
                </SwiperSlide>
            </Swiper>
        </>
    )
}

export default SliderBanner